import { render, staticRenderFns } from "./income.vue?vue&type=template&id=47fd1522&scoped=true&"
import script from "./income.vue?vue&type=script&lang=js&"
export * from "./income.vue?vue&type=script&lang=js&"
import style0 from "./income.vue?vue&type=style&index=0&id=47fd1522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd1522",
  null
  
)

export default component.exports